import { authorizedApi } from './index';

export const giftFeesApi = authorizedApi.injectEndpoints({
  endpoints: (builder) => ({
    getGiftFees: builder.query({
      query: ({ token, tokenAmount, delivery }) => ({
        url: '/gift-fees/',
        params: { token, tokenAmount, delivery },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetGiftFeesQuery, useLazyGetGiftFeesQuery } = giftFeesApi;
